

module.exports = __webpack_require__.stylable.create(
    "Description2275245606",
    {"classes":{"root":"Description2275245606__root","description":"Description2275245606__description"},"vars":{},"stVars":{},"keyframes":{}},
    "",
    1,
    "Description2275245606",
    null
);
